import { Component, effect, input, output, ChangeDetectionStrategy } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';

@Component({
    selector: 'app-field',
    templateUrl: './field.component.html',
    styleUrls: ['./field.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class FieldComponent {
    readonly field = input<any>();
    readonly tagControl = input<FormControl>();
    readonly id = input<string>();
    readonly formGroup = input<FormGroup>();

    delete = output<any>();

    get isReady(): boolean {
        return !!this.field && !!this.formGroup();
    }

    readonly metaName: any = { id: 'name', name: 'Field Name', info: 'Name of the field', mandatory: true };
    readonly metaType: any = { id: 'typeId', name: 'Field Data Type', info: 'Data type of the field', mandatory: true };
    readonly metaInfo: any = { id: 'info', name: 'Field Info', info: 'Info of the field' };
    readonly metaMandatory: any = { id: 'mandatory', name: '', info: 'Mandatory' };
    readonly metaMeta: any = { id: 'meta', name: 'Field Metadata', info: 'Custome metadata of the field', rows: 12, textStyle: '{"font-family":"monospace"}' };

    hideMeta: boolean = true;

    constructor() {

        effect(() => {
            const formGroup = this.formGroup();
            const tagControl = this.tagControl();
            const field = this.field();
            const id = this.id();

            if (formGroup && tagControl && id) {
                formGroup.addControl('tag', tagControl);
                formGroup.addControl('id', new FormControl(id));
                if (field.value.readonly) {
                    formGroup.addControl('readonly', new FormControl(field.value.readonly));
                }
            }
        });
    }

    onDelete(field: any) {
        this.delete.emit(field);
    }

    onMeta() {
        this.hideMeta = !this.hideMeta;
    }
}
